import { ref } from 'vue'

const isTransitioning = ref(false)
const isScaling = ref(false)
const transitionTitle = ref('')

export function usePageTransition() {
  const triggerTransition = (title, navigationCallback) => {
    transitionTitle.value = title
    isTransitioning.value = true
    isScaling.value = false

    // Wait for enter animation (e.g. 800ms)
    setTimeout(() => {
      // Perform navigation
      if (navigationCallback) navigationCallback()

      // Trigger Title Scale Up effect immediately after navigation starts
      // This happens while curtain is still closed
      setTimeout(() => {
        isScaling.value = true
      }, 50)

      // Wait for navigation/DOM update + Scale Animation timing
      // Then open the curtains
      setTimeout(() => {
        isTransitioning.value = false
        // Reset Scaling state
        setTimeout(() => {
          isScaling.value = false
          transitionTitle.value = ''
        }, 800)
      }, 500) // Delay before opening (reduced for speed)
    }, 800) // Duration of "closing" animation
  }

  return {
    isTransitioning,
    isScaling,
    transitionTitle,
    triggerTransition,
  }
}
